import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FileDropZone } from '../../_metronic/layout/components/dropzone/FileDropZone'
import FormFooterButtons from '../components/FormFooterButtons';
import { Card } from 'react-bootstrap';
import ImageUploader from "../components/ImageUploader";

const Medical = (props) => (
    <div>
        <Formik
            enableReinitialize
            initialValues={props.data ? props.data : {
                ward: "",
                name: "",
                issuedNumber: "",
                contactNumber: "",
                address: "",
                service: "",
                ownerName: "",
            }}
            validate={values => {
                const errors = {};
                // if (!values.name) {
                //     errors.name = 'Required';
                // }
                // if (!values.ward) {
                //     errors.ward = 'Required';
                // }
                // if (!values.infrastructure) {
                //     errors.infrastructure = 'Required';
                // }
                // if (!values.haatbazaarName) {
                //     errors.haatbazaarName = 'Required';
                // }
                // if (!values.haatrWard) {
                //     errors.haatrWard = 'Required';
                // }
                // if (!values.haatMarket) {
                //     errors.haatMarket = 'Required';
                // }
                // if (!values.haatInfra) {
                //     errors.haatInfra = 'Required';
                // }
                // if (!values.haatType) {
                //     errors.haatType = 'Required';
                // }
                return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
                console.log(values)
                setTimeout(() => {
                    props.submit(values);
                    setSubmitting(false);
                }, 400);
            }}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                handleReset, }) => (
                <>
                    <form className="form survey-form" onSubmit={handleSubmit}>
                        <Card>
                            <Card.Body>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >नाम</label>
                                        <input type="text" className="form-control" placeholder="नाम" name="name" onChange={handleChange} value={values.name} />
                                        <ErrorMessage className="invalid-feedback" name="name" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >वडा नम्बर</label>
                                        <input type="number" className="form-control" placeholder="वडा नम्बर" name="ward" onChange={handleChange} value={values.ward} />
                                        <ErrorMessage className="invalid-feedback" name="ward" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >ठेगाना</label>
                                        <input type="text" className="form-control" placeholder="" name="address" onChange={handleChange} value={values.address} />
                                        <ErrorMessage className="invalid-feedback" name="address" component="div" />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <label className="form-control-label" >दर्ता नं</label>
                                        <input type="number" className="form-control" placeholder="दर्ता नं" name="issuedNumber" onChange={handleChange} value={values.issuedNumber} />
                                        <ErrorMessage className="invalid-feedback" name="issuedNumber" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >उपलब्ध सेवा</label>
                                        <textarea type="text" class="form-control" id="exampleTextarea" rows="3" name="service" onChange={handleChange} value={values.service} ></textarea>
                                        <ErrorMessage className="invalid-feedback" name="scienceCount" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-control-label" >स्वामित्व(कोसंग)</label>
                                        <input type="text" className="form-control" placeholder="" name="ownerName" onChange={handleChange} value={values.ownerName} />
                                        <ErrorMessage className="invalid-feedback" name="ownerName" component="div" />
                                    </div>
                                    <div className="col-md-6">
                                        <label>फोटो</label>
                                        <ImageUploader fileListContent={props.fileListContent} />
                                    </div>
                                </div>
                                <div className="card-footer text-right">
                                    <FormFooterButtons />
                                </div>
                            </Card.Body>
                        </Card>

                    </form>
                </>
            )}
        </Formik>
    </div >
);

export default Medical;